import Vue from 'vue'
// models component
import ShipSpare from '@/models/ShipSpare'
import ShipSpareSummary from '@/models/ShipSpareSummary'

export default class ShipSpareFetch {
    // Ship Spares Fetch
    static of(shipId, params) {
        return Promise.resolve()
            .then(function () {
                ShipSpare.deleteAll()
                return ShipSpare.api()
                    .fetch(shipId, params)
                    .then(function (result) {
                        console.log('ShipSpare.all()', ShipSpare.all())
                    })
            })
            .then(function () {
                return ShipSpareSummary.api()
                    .fetch(shipId)
                    .then(function (result) {
                        console.log(
                            'ShipSpareSummary.findByShipId()',
                            ShipSpareSummary.findByShipId(shipId)
                        )
                    })
            })
            .catch(() => {
                return new Promise((resolve, reject) => {
                    reject(new Error())
                })
            })
    }
}
